import { Level1, Level2, Level3 } from '@lyearn/icons';
import { DifficultyEnum } from '@/types/schema';

type Config = Record<DifficultyEnum, { Icon: typeof Level1; labelKey: string }>;

export const QUESTION_DIFFICULTY_CONFIG: Config = {
  [DifficultyEnum.Easy]: {
    Icon: Level1,
    labelKey: 'QuizCreator:QuestionsSettings.Easy',
  },
  [DifficultyEnum.Medium]: {
    Icon: Level2,
    labelKey: 'QuizCreator:QuestionsSettings.Medium',
  },
  [DifficultyEnum.Hard]: {
    Icon: Level3,
    labelKey: 'QuizCreator:QuestionsSettings.Hard',
  },
  [DifficultyEnum.Na]: {
    Icon: (props) => <Level3 {...props} fillColorToken="icon-placeholder" />,
    labelKey: 'QuizCreator:QuestionsSettings.NoDifficulty',
  },
};
